/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from "react";
import { Toaster } from "react-hot-toast";
import { DEFAULT_APP_CONFIG } from "../config/default.config";
import { useTheme } from "../providers/theme";
import { LoginModalVW } from "../widgets/LoginModalVW";
import { StateOSDModalVW } from "../widgets/StateOSDModalVW";
import { VApplication } from "../application";
import { WalletconnectModule } from "@vlinder-web/walletconnect-module-react";

const getWalletModule = () => {
    const vapp = VApplication.getInstance();
    const walletconnentModule = vapp.getSync(
        "services.WalletconnectModule"
    ) as WalletconnectModule;
    return walletconnentModule;
};

export const Accessories = () => {
    const theme = useTheme();
    if (sessionStorage.getItem("reloaded") != null) {
        console.log("page was reloaded");
        const module = getWalletModule();
        module
            .killSession()
            .then((res) => {})
            .catch((err) => {});
    } else {
        console.log("page was not reloaded");
    }
    sessionStorage.setItem("reloaded", "yes");

    window.addEventListener("beforeunload", async function (e) {
        const module = getWalletModule();
        module
            .killSession()
            .then((res) => {})
            .catch((err) => {});

        // e.preventDefault();
        // e.returnValue = '';
    });

    return (
        <>
            <StateOSDModalVW />
            <LoginModalVW
                apiURL={DEFAULT_APP_CONFIG?.servers?.rest?.loginServer?.baseURL}
            />
            <Toaster
                toastOptions={{
                    className: "",
                    duration: 8000,
                    style: {
                        borderLeft: `4px solid ${theme?.colors?.primary}`,
                        padding: "16px",
                        color: theme?.colors?.black,
                        fontSize: 15,
                        fontWeight: "bolder",
                    },
                    success: {
                        style: {
                            borderColor: theme?.colors?.toastSuccess,
                        },
                    },
                    error: {
                        style: {
                            borderColor: theme?.colors?.toastError,
                        },
                    },
                }}
            />
        </>
    );
};
